import React, { useState } from 'react'
import { Helmet } from 'react-helmet';
import './styling/login.css';
import Button from 'nokia-react-components/Button'
import './styling/footer.css';
import './styling/mainPage.css';
import './styling/banner.css';
import './styling/exploreFeatures.css';

export default function Login() {
    const [product, setProduct] = useState('https://documentation.nokia.com/aces/sros/rn-navigator/');
    const [selectedProduct, setSelectedProduct] = useState('SR OS');

    return (
        <>
            <Helmet>
                <meta name="description" content="Use this tool to explore software feature information for one of the following products 7250 IXR, 7450 ESS, 7750 SR, 7950 XRS, VSR, and MAG-c" />
            </Helmet>
            <div className="login-container" style={{ width: "100%" }}>
                <div className="left-div" style={{ width: '50%', float: 'left' }}>
                </div>
                <div className='right-div'>
                    <div className='main-login'>
                        <div className='banner-login-container'>
                            <img loading='lazy' />
                        </div>
                        <div className='login-heading'>
                            <p>Release Notes Navigator</p>
                        </div>
                        <div className='intro-container' style={{ backgroundColor: 'transparent' }}>
                            <p style={{ fontSize: '14px', backgroundColor: 'transparent', color: 'black' }}>Use this tool to explore software feature information for one of the products below.</p>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '60px' }}>
                            <Button
                                style={{
                                    background: selectedProduct === 'SR OS' ? ' #CCCCCC' : 'white',
                                    color: '#005AFF',
                                    border: '1.5px solid #CCCCCC',
                                    fontSize: '12px',
                                    marginTop: '20px'
                                }}
                                onClick={() => {
                                    setSelectedProduct('SR OS');
                                    setProduct('https://documentation.nokia.com/aces/sros/rn-navigator/');
                                }}
                            >
                                SR OS
                            </Button>

                            <Button
                                style={{
                                    background: selectedProduct === 'SR Linux' ? ' #CCCCCC' : 'white',
                                    color: '#005AFF',
                                    border: '1.5px solid #CCCCCC',
                                    fontSize: '12px',
                                    marginTop: '20px'
                                }}
                                onClick={() => { setSelectedProduct('SR Linux'); setProduct('https://documentation.nokia.com/aces/srlinux/rn-navigator/'); }}
                            >
                                SR Linux
                            </Button>

                            <Button
                                style={{
                                    background: selectedProduct === 'EDA' ? ' #CCCCCC' : 'white',
                                    color: '#005AFF',
                                    border: '1.5px solid #CCCCCC',
                                    fontSize: '12px',
                                    marginTop: '20px'
                                }}
                                onClick={() => { setSelectedProduct('EDA'); setProduct('https://documentation.nokia.com/eda/rn-navigator/'); }}
                            >
                                EDA
                            </Button>

                            <Button
                                style={{
                                    background: selectedProduct === 'MAG-c' ? ' #CCCCCC' : 'white',
                                    color: '#005AFF',
                                    border: '1.5px solid #CCCCCC',
                                    fontSize: '12px',
                                    marginTop: '-20px'
                                }}
                                onClick={() => { setSelectedProduct('MAG-c'); setProduct('https://documentation.nokia.com/aces/mag-c/rn-navigator/'); }}
                            >
                                MAG-c
                            </Button>

                            <Button
                                style={{
                                    background: selectedProduct === 'cMAG-c' ? ' #CCCCCC' : 'white',
                                    color: '#005AFF',
                                    border: '1.5px solid #CCCCCC',
                                    fontSize: '12px',
                                    marginTop: '-20px'
                                }}
                                onClick={() => { setSelectedProduct('cMAG-c'); setProduct('https://documentation.nokia.com/aces/cmag-c/rn-navigator/'); }}
                            >
                                cMAG-c
                            </Button>

                            <Button
                                style={{
                                    background: selectedProduct === '7210 SAS' ? ' #CCCCCC' : 'white',
                                    color: '#005AFF',
                                    border: '1.5px solid #CCCCCC',
                                    fontSize: '12px',
                                    marginTop: '-20px'
                                }}
                                onClick={() => { setSelectedProduct('7210 SAS'); setProduct('https://documentation.nokia.com/aces/sas/rn-navigator/'); }}
                            >
                                7210 SAS
                            </Button>
                        </div>

                        <hr style={{ borderTop: '1px solid #CCCCCC', margin: '20px 0', marginTop: '40px' }} />

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                style={{ background: '#005AFF', color: 'white', marginTop: '20px' }}
                                onClick={() => {
                                    // Navigate to the sindexpecified URL
                                    window.location.href = product;
                                }}
                            >
                                SIGN IN
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
